<template>
  <SectionHeader
    :show-content="rateLimitShowContents"
    :widget-title="$t('HEADER_RATE_LIMIT')"
    @onShowContentsClick="onRateLimitShowContentsClick()"
  >
    <template #content>
      <form
        role="form"
        class="form-horizontal"
        name="rateLimit"
      >
        <div v-if="overridesAvailable">
          <Field
            :label="$t('LABEL_OVERRIDE_RATE_LIMIT')"
            :hide-label="false"
            :has-tooltip="true"
            :tooltip-text="$t('TOOLTIP_OVERRIDE_RATE_LIMIT')"
          >
            <template #element>
              <div class="p-l-0 col-sm-5 col-md-1">
                <ValidationProvider
                  rules="required"
                  slim
                >
                  <nzToggle
                    v-model="overrideRateLimitSettings"
                    data-cy="rate-limit-overide-toggle"
                    @onToggle="overrideRateLimitSettingsToggle"
                  />
                </ValidationProvider>
              </div>
            </template>
          </Field>
        </div>
      
        <div v-if="!overridesAvailable || overrideRateLimitSettings">
          <Field
            :label="$t('LABEL_MAXIMUM_REQUESTS')"
            :hide-label="false"
            :has-tooltip="true"
            :tooltip-text="$t('TOOLTIP_MAXIMUM_REQUESTS')"
          >
            <template #element>
              <ValidationProvider
                v-slot="{ classes, errors }"
                rules="required|min_value:1|integer"
                slim
              >
                <div class="p-l-0 col-sm-5 col-md-1">
                  <input
                    :value="maxRequests"
                    name="currentmaxRequests"
                    data-cy="currentmaxRequests"
                    :placeholder="$t('LABEL_PLACEHOLDER_MAXIMUM_REQUESTS')"
                    class="form-control"
                    :class="classes"
                    type="number"
                    :disabled="affiliateView"
                    @input="onMaximumRequestsOnInput"
                    @change="onMaximumRequestsOnChange"
                    @wheel="$event.target.blur()"
                  >
                </div>
                <label
                  v-if="errors[0]"
                  name="currentmaxRequests-invalid-label"
                  data-cy="currentmaxRequests-invalid-label"
                  class="form-group__label-required vv-invalid"
                >{{ $t('ERROR_MAXIMUM_REQUEST') }}
                </label>
                <label
                  v-else
                  class="form-group__label-required"
                >{{ $t('REQUIRED') }}
                </label>
              </ValidationProvider>
              
              <ValidationProvider
                v-slot="{ classes }"
                rules="required"
                slim
              >
                <div class="col-sm-5 col-md-2">
                  <SearchableDropdown
                    v-model="perSeconds"
                    name="perSeconds"
                    class="rtb-default-selector m-b-10"
                    :class="classes"
                    :config="perSecondsDropdownConfig"
                    :disabled="affiliateView"
                    :searchable="false"
                    :clearable="false"
                    @change="onPerSecondsDropdownOnChange"
                  />
                </div>
              </ValidationProvider>
            </template>
          </Field>

          <Field
            v-if="showMaximumRequestsMessage()"
            :label="''"
            :hide-label="false"
          >
            <template #element>
              <label v-if="!affiliateView && maxRequests > 0">
              <template v-if="overridesAvailable">
                  {{ $t('MESSAGE_MAXIMUM_REQUEST_OVERRIDE', { maxRequests: maxRequests, period: perSeconds.toLowerCase() }) }}
              </template>
              <template v-else>
                  {{ $t('MESSAGE_MAXIMUM_REQUEST', { maxRequests: maxRequests, period: perSeconds.toLowerCase() }) }}
              </template>
              </label>
              <label v-if="affiliateView">
                 {{ $t('MESSAGE_MAXIMUM_REQUEST_AFFILIATE', { maxRequests: maxRequests, period: perSeconds.toLowerCase() }) }}
              </label>
            </template>
          </Field>
        </div>
      </form>
    </template>
  </SectionHeader>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

import SectionHeader from '@/core/components/SectionHeader/SectionHeader';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import nzToggle from '@/core/components/nzToggle/nzToggle';

export default {
  name: 'RateLimit',
  components: { SectionHeader, Field, SearchableDropdown, nzToggle },
  props: {
    maxRequests: {
      type: String,
      default: () => {
        return '';
      }
    },
    perSeconds: {
      type: String,
      default: () => {
        return '';
      }
    },
    perSecondsDropdownConfig: {
      type: Object,
      default: () => {
        return{};
      }
    },
    overridesAvailable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    overrideRateLimitSettings: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    hideSaveAndCancel: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    affiliateView: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      rateLimitShowContents: true,
    };
  },
  methods: {
    overrideRateLimitSettingsToggle(val) {
      this.$emit('overrideRateLimitSettingsToggle', val);
    },
    onRateLimitShowContentsClick(){
      this.rateLimitShowContents = !this.rateLimitShowContents;
    },
    onMaximumRequestsOnInput(val) {
      this.$emit('onMaximumRequestsOnInput', val);
    },
    onMaximumRequestsOnChange(val) {
      this.$emit('onMaximumRequestsOnChange', val);
    },
    onPerSecondsDropdownOnChange(val) {
      this.$emit('onPerSecondsDropdownOnChange', val);
    },
    showMaximumRequestsMessage(){
      return (this.maxRequests.length > 0) && (this.perSeconds.length > 0);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>